module.exports = __webpack_public_path__ + "fonts/Inter-Medium.5b53c51.woff2";